import React from 'react';
import { useReveal } from '../hooks/useInView';

const STATS = [
  { value: '6.8 kg',  label: 'Avg loss in 8 weeks*' },
  { value: '24',      label: 'Verified clinics' },
  { value: '100%',    label: 'MMC-registered doctors' },
  { value: '4.9 / 5', label: 'User satisfaction' }
];

const CLINIC_LOGOS = [
  'KL WEIGHT CLINIC',
  'BANGSAR MEDICAL',
  'PETALING METABOLIC',
  'JOHOR ENDO',
  'PENANG WELLNESS',
  'IPOH MEDIC'
];

export default function SocialProof() {
  const a = useReveal();
  const b = useReveal({ threshold: 0.05 });
  return (
    <section className="border-y border-ink-200 bg-ink-50">
      <div className="container-x py-14 sm:py-16">
        <div ref={a.ref} className={a.className}>
          <p className="text-sm uppercase tracking-[0.18em] text-ink-500 text-center">
            Trusted by patients across Malaysia
          </p>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6">
            {STATS.map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
                  {s.value}
                </div>
                <div className="mt-1 text-sm text-ink-500">{s.label}</div>
              </div>
            ))}
          </div>

          <p className="mt-4 text-center text-[11px] text-ink-400">
            *Indicative outcome from a 2-bottle plan. Individual results vary based on
            adherence, lifestyle, and underlying conditions.
          </p>
        </div>

        <div ref={b.ref} className={`${b.className} mt-12`}>
          <p className="text-xs uppercase tracking-[0.18em] text-ink-400 text-center mb-4">
            Partner clinics
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-6 gap-x-8 items-center">
            {CLINIC_LOGOS.map((l) => (
              <div
                key={l}
                className="text-center text-xs sm:text-sm font-semibold tracking-[0.2em] text-ink-400 hover:text-ink-700 transition-colors"
              >
                {l}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
